import clsx from 'clsx';
import React from 'react';

import { useTimeout } from 'lib/Hooks';
import { useIsShowroomMobileVersion } from 'lib/showroom';

import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVertOutlined';

import ShowroomMobileActionsMenuLayout from 'components/Showroom/MobileActionsMenuLayout';

import { useStyles } from './styles';

export type ComponentProps = {
	id: string;
	actions: React.ReactNode;
	mobileActions: React.ReactNode;
	displayed: boolean;
	mobileMenuOpen: boolean;
	children?: React.ReactNode;
	onDisplay(): void;
	onHide(): void;
	onOpenMobileMenu(): void;
	onCloseMobileMenu(): void;
};

const ShowroomMediaActionsLayout = (props: ComponentProps) => {
	const { id, actions, mobileActions, displayed, children, mobileMenuOpen } = props;
	const { onDisplay, onHide, onOpenMobileMenu, onCloseMobileMenu } = props;

	const { run: runTimeout, clear: clearTimeout } = useTimeout();

	const onMouseEnterHandler = React.useCallback(() => onDisplay(), [onDisplay]);
	const onMouseLeaveHandler = React.useCallback(() => onHide(), [onHide]);
	const onTouchStartHandler = React.useCallback(() => runTimeout(() => onOpenMobileMenu(), 500), [onOpenMobileMenu, runTimeout]);
	const onTouchEndHandler = React.useCallback(() => clearTimeout(), [clearTimeout]);

	const classes = useStyles();
	const mobileVersion = useIsShowroomMobileVersion();

	return (
		<div
			id={`${id}_wrapper`}
			className={classes.wrapper}
			onMouseEnter={onMouseEnterHandler}
			onMouseLeave={onMouseLeaveHandler}
			onContextMenu={ev => ev.preventDefault()}
			onTouchStart={onTouchStartHandler}
			onTouchEnd={onTouchEndHandler}
		>
			<div id={`${id}_actionsContainer`} className={clsx(classes.mediaActionsWrapper, { [classes.mediaActionsWrapperMobile]: mobileVersion })}>
				<div className={classes.mediaActionsInnerWrapper}>
					<div className={clsx(classes.mediaActionsContainer, { [classes.mediaActionsContainerVisible]: displayed || mobileVersion })}>
						{mobileVersion ? (
							<>
								<IconButton
									id={`${id}_mobileActionsButton`}
									className={classes.actionsMobileButton}
									onClick={() => onOpenMobileMenu()}
								>
									<MoreVertIcon className={classes.actionsMobileIcon} />
								</IconButton>
								<ShowroomMobileActionsMenuLayout open={mobileMenuOpen} onClose={() => onCloseMobileMenu()}>
									{mobileActions}
								</ShowroomMobileActionsMenuLayout>
							</>
						) : (
							<div className={classes.actionsMenuDesktop}>{actions}</div>
						)}
					</div>
				</div>
			</div>
			{children}
		</div>
	);
};

export default React.memo(ShowroomMediaActionsLayout);
